export default {"src":"/_next/static/media/add.0de24297.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};